define.alias("shared/components/shared/social/twitter-deprecation/modal", "media/components/shared/social/twitter-deprecation/modal");